/////////////////////////////////////////////////
//
// Manages the Mask on mymuesli App
//
// Require:
// app/data/scss/static/_mask.scss
// app/templates/Layout/Components/Mask.php
//
////////////////////////////////////////////////////////////
(() => {
    class Mask {
        constructor() {
            this.element    = $('.mask');
            this.active     = this.element.hasClass('active');
            this.isFixed    = false;

            this.preloaders = {
                standard: '/assets/img/Components/ladebalken.gif',
                list: [
                    '/assets/img/preloader/ingredients/raspberry.svg',
                    '/assets/img/preloader/ingredients/blueberry.svg',
                ],
            };
            // default values
            this.defaultValues = {
                classes:        this.element.attr('class') ? this.element.attr('class') : null,
                isFixed:        this.isFixed,
            };
            this.hideAction = [];
            this.run();
        }

        /* SETTERS */
        set message(message) {
            this.element.html('<span class="message">' + message + '</span>');
        }
        set background(background) {
            this.element.css('background-image', 'url(' + background + ')');
        }

        // Hide Mask
        hide() {
            this.active     = false;
            this.isFixed    = false;
            this.reset();
            this.element.removeClass('active');
        }

        // Show Mask
        show() {
            this.element.addClass('active');
            this._preloader ? this.element.addClass('preloader') : this.element.removeClass('preloader');
            this.active = true;
            return this;
        }

        fullscreen(fullscreen = true) {
            if (fullscreen) {
                this.element.addClass('fullscreen');
            } else {
                this.element.removeClass('fullscreen');
            }
            return this;
        }

        transparent() {
            this.element.addClass('transparent');
            return this;
        }

        large() {
            this.element.addClass('large');
            return this;
        }

        // Reset Mask to its original state
        reset() {
            this._preloader = false;
            setTimeout(() => {
                this.background = this.preloaders.standard;
                this.isFixed = this.defaultValues.isFixed;
            }, App.Setting('FX_DURATION_SHORT'));
            this.element.attr('class', this.defaultValues.classes);
            this.message = '';
        }

        // do not hide mask on self click
        fixed() {
            this.fullscreen();
            this.isFixed = true;
            return this;
        }

        // Show Mask as a preloader
        preloader(preloader = true) {
            this.fullscreen(preloader);
            this._preloader = preloader;
            return this;
        }

        // Show a message
        setMessage(message) {
            this.message = message;
            this.background = this.getRandomPreloader();
            this
                .preloader()
                .show()
            ;
            return this;
        }

        setBackground(image) {
            this.background = image;
            return this;
        }

        getRandomPreloader() {
            let preloaders = this.preloaders.list;
            return preloaders[Math.floor(Math.random() * preloaders.length)];
        }

        onHide(callback) {
            this.hideAction.push(callback);
        }

        on(event, callback) {
            this.element.on(event, callback);
        }

        success(autohide = true) {
            this.background ='/assets/img/preloader/success.svg';
            this
                .fullscreen()
                .preloader()
                .show()
            ;
            if (autohide) setTimeout(() => this.hide(), 1000);
        }

        error(message = __('DEFAULT.404.TEXT')) {
            this.setMessage(message);
            this.background ='/assets/img/preloader/error.svg';
            this
                .fullscreen()
                .preloader()
                .show()
            ;
        }

        run() {
            var instance = this;
            this.element.click(function() {
                if (!instance.isFixed) {
                    instance.hideAction.forEach(function(callback) {
                        callback();
                    });
                    instance.hide();
                }
            });
        }
    }
    App.Interface.Mask = new Mask();
})();
